import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { TEMPLATES } from "./templates";

export default function TemplateGallery({ open, onOpenChange, onApply, hasExistingBlocks }) {
  const handleApply = (key) => {
    if (hasExistingBlocks) {
      const ok = window.confirm(
        "Wybor szablonu ZASTAPI obecny uklad strony. Niezapisane zmiany w blokach moga zostac utracone. Kontynuowac?"
      );
      if (!ok) return;
    }
    onApply(key);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Wybierz szablon strony</DialogTitle>
          <DialogDescription>
            Szablon wypelni strone gotowymi blokami dopasowanymi do branzy. Mozesz pozniej dowolnie edytowac.
          </DialogDescription>
        </DialogHeader>

        <div className="grid sm:grid-cols-2 gap-3 mt-2">
          {Object.entries(TEMPLATES).map(([key, tpl]) => (
            <button
              key={key}
              onClick={() => handleApply(key)}
              className="text-left border border-slate-200 rounded-lg p-4 hover:border-emerald-400 hover:bg-emerald-50/30 transition-colors"
            >
              <div className="flex items-center justify-between mb-1">
                <span className="font-semibold text-sm">{tpl.label}</span>
                <Badge variant="outline" className="text-xs">
                  {tpl.industry}
                </Badge>
              </div>
              <p className="text-xs text-slate-500 mb-2">{tpl.description}</p>
              <div className="flex flex-wrap gap-1">
                {tpl.blocks.map((b, i) => (
                  <span
                    key={i}
                    className="text-[10px] bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded font-mono"
                  >
                    {b.type}
                  </span>
                ))}
              </div>
            </button>
          ))}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Anuluj
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
